<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <main
      :class="'scrollable container'"
      :style="{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }"
    >
      <CreatedUserSvg />
      <h2 :style="{marginBottom: '20px'}">Account created!</h2>
      <p
        :class="'t16'"
        :style="{marginBottom: '30px'}"
      >
        Your account had beed created successfully.
      </p>
      <Button
        :title="'Done'"
        :containerStyle="{width: '50%'}"
        :onClick="() => $router.push(routes.SIGN_IN)"
      />
    </main>
  </div>
</template>

<script setup>
// others
import {routes} from '@/routes';
import {useOpacity} from '@/hooks';

// components
import {Button} from '@/components';
import {Background} from '@/components';

// svg
import {CreatedUserSvg} from '@/assets/svg';

const opacity = useOpacity();
</script>
